import React from "react";
import { Avatar, Box, Button, Typography } from "@mui/material";
import styled from "styled-components";
import { Link, LinkProps } from "react-router-dom";
import { COLORS } from "assets/colors";
import { DollarTag } from "api";
import { colorMap } from "constants/index";
import { CLICK_SEARCH_RESULT } from "utills/events";
import ReactGA from "react-ga4";
import { SearchTag } from "layouts/MainLayout/components/Search";
import { SearchCardWraper } from "./SearchCardWraper";
import { useWindowWidth } from "@react-hook/window-size";
interface StocksSearchCardProps {
  dollar: {
    __typename?: "DollarTag" | undefined;
  } & Pick<
    DollarTag,
    "dollarTagId" | "dollarTagName" | "slug" | "dollarTagType"
  >;

  isAnchor?: boolean;
  handleAddChip?: (data: SearchTag) => void;
  handleGetFilterPosts?: (data: SearchTag | undefined) => void;
}

const StocksSearchCard: React.FC<StocksSearchCardProps> = ({
  dollar,

  isAnchor,
  handleAddChip,
  handleGetFilterPosts
}) => {
  const onClick = () => {
    handleGetFilterPosts?.({
      id: Number(dollar?.dollarTagId),
      name: dollar.dollarTagName,
      tag: "dollar",
      slug: `${dollar.slug}`,
      dollarTagType: dollar.dollarTagType
    })

  }
  const width = useWindowWidth();
  return (
    <MainWrap onClick={() => {
      ReactGA.event(CLICK_SEARCH_RESULT, {});
    }}>
      <SearchCardWraper
        to={`/${dollar?.dollarTagType?.toLocaleLowerCase()}/${dollar?.slug}/${dollar?.dollarTagId}`}
        isAnchor={isAnchor}
        onClick={onClick}
      >
        <Avatar>$</Avatar>
        <TextWrap>
          <Typography variant="subtitle2" sx={{ textAlign: "left" }}>{`${dollar?.dollarTagName}`}</Typography>
          <Typography variant="caption" sx={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
            <span style={{ color: colorMap[dollar?.dollarTagType] }}>
              in {dollar?.dollarTagType}
            </span>
          </Typography>
        </TextWrap>
      </SearchCardWraper>
      <ViewDetails
        sx={{ width: width <= 540 ? "55px" : "130px" }}
        onClick={() => {
          handleAddChip?.({
            id: Number(dollar?.dollarTagId),
            name: dollar.dollarTagName,
            tag: "dollar",
            slug: `${dollar.slug}`,
            dollarTagType: dollar.dollarTagType
          })
          ReactGA.event(CLICK_SEARCH_RESULT, {});
        }}
      >
        <span style={{ marginRight: width > 540 ? "5px" : "0px" }}>
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_108_13"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="12"
              height="12"
            >
              <path d="M0 0H12V12H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_108_13)">
              <path
                d="M9.5 0C9.77615 0 10 0.223857 10 0.5V4.5C10 4.77614 9.77615 5 9.5 5C9.22385 5 9 4.77614 9 4.5V0.5C9 0.223857 9.22385 0 9.5 0Z"
                fill="#5C7082"
              />
              <path
                d="M7 2.5C7 2.22386 7.22385 2 7.5 2H11.5C11.7761 2 12 2.22386 12 2.5C12 2.77614 11.7761 3 11.5 3H7.5C7.22385 3 7 2.77614 7 2.5Z"
                fill="#5C7082"
              />
              <path
                d="M0 5C0 2.22386 2.22386 0 5 0C5.27615 0 5.5 0.223857 5.5 0.5C5.5 0.77614 5.27615 1 5 1C2.77614 1 1 2.77614 1 5C1 7.22385 2.77614 9 5 9C6.63815 9 8.0661 7.98 8.6919 6.5496C8.8026 6.2966 9.0974 6.18125 9.3504 6.2919C9.6034 6.4026 9.71875 6.6974 9.6081 6.9504C8.8339 8.72 7.06185 10 5 10C2.22386 10 0 7.77615 0 5Z"
                fill="#5C7082"
              />
              <path
                d="M7.84645 7.84645C8.0417 7.6512 8.3583 7.6512 8.55355 7.84645L11.8535 11.1464C12.0488 11.3417 12.0488 11.6583 11.8535 11.8535C11.6583 12.0488 11.3417 12.0488 11.1464 11.8535L7.84645 8.55355C7.6512 8.3583 7.6512 8.0417 7.84645 7.84645Z"
                fill="#5C7082"
              />
            </g>
          </svg>
        </span>
        {width >= 540 ? <span style={{ whiteSpace: "nowrap" }}>Add to Search</span> : null}
      </ViewDetails>
    </MainWrap>
  );
};

export default StocksSearchCard;

const ViewDetails = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 12px;
  text-decoration: none;
  font-style: Trebuchet MS;
  font-weight: 400;
  font-size: 12px;
  color: rgba(92, 112, 130, 1);
  cursor: pointer;
 
`;

const MainWrap = styled(Box)`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: rgba(0, 0, 0, 0.025);
    .title {
      color: ${COLORS.lightBlue};
    }
  }
`;
const Wrap = styled(Link)`
  display: flex;
  align-items: flex-start;
  // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  max-width:520px;
  width:100%;
  padding: 6px 12px;
  text-decoration: none;
  cursor:pointer;

  .title {
    font-size: 14px;
    font-weight: 700;
    color: ${COLORS.blue};
  }

  .sub-title {
    font-size: 12px;
    color: ${COLORS.mutedDark};
  }

  // &:hover {
  //   background-color: rgba(0, 0, 0, 0.025);
  //   .title {
  //     color: ${COLORS.lightBlue};
  //   }
  //}
` as React.ComponentType<LinkProps>;

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;
